// Opens the audit trail detail modal and loads version history into a Turbo Frame.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    event.preventDefault();
    const el = event.currentTarget;
    const url = el.dataset.auditTrailModalUrl;
    if (!url) return;

    // Show modal overlay
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden");

    // Completely destroy and recreate the turbo frame
    const oldFrame = document.getElementById("audit_trail_modal");
    if (oldFrame) {
      oldFrame.remove();
    }

    // Create new turbo frame
    const newFrame = document.createElement("turbo-frame");
    newFrame.id = "audit_trail_modal";
    newFrame.innerHTML = `<div data-audit-trail-modal-target="content" class="space-y-4">Loading...</div>`;

    // Find the container and append the new frame
    const modalContainer = this.modalTarget.querySelector(".p-6.overflow-y-auto");
    if (modalContainer) {
      modalContainer.appendChild(newFrame);
    }

    const separator = url.includes("?") ? "&" : "?";
    newFrame.setAttribute("src", `${url}${separator}_ts=${Date.now()}`);
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    // Clear Turbo Frame content and src for next open
    const turboFrame = document.getElementById("audit_trail_modal")
    if (turboFrame) {
      turboFrame.removeAttribute("src")
      turboFrame.innerHTML = `<div data-audit-trail-modal-target="content" class="space-y-4"></div>`
    }
  }
}
